import React from 'react';
import { FaArrowLeft } from 'react-icons/fa6';

import HistoryItem from './history-item/history-item.component';
import useHistory from './history.controller';

const ID = 'history';

export const History = () => {
    const viewProps = useHistory();

    return (
        <div
            id={ID}
            aria-label='history'>
            <ol className='d-flex justify-content-center justify-content-md-start align-items-center breadcrumb m-0 bg-transparent p-0'>
                {viewProps.history.length > 1 && (
                    <li
                        className='d-flex breadcrumb-item align-items-center m-1 p-0 text-sm text-white'
                        id={ID}
                        onClick={viewProps.back}>
                        <FaArrowLeft />
                    </li>
                )}
                {viewProps.history.map((item, index) => (
                    <HistoryItem
                        key={index}
                        path={item}
                        isLast={index === viewProps.history.length - 1}
                        onClick={() => viewProps.onClick(index)}
                    />
                ))}
            </ol>
        </div>
    );
};

export default History;
